import { ChangeEnum, ConfirmedEnum, CountingStateEnum, OperateEnum, OperateEnum2, OrderEnum } from "@/types/inventory";
import { WLocation } from "@/types/inventoryV2";
import i18next from "i18next";

export const opTypes = [
  { value: OperateEnum.PENDING, label: i18next.t('inventory.inv'), colorKey: 'gold' },
  { value: OperateEnum.TRANSACTION, label: i18next.t('inventory.trade'), colorKey: 'purple' },
  { value: OperateEnum.DISPATCH, label: i18next.t('inventory.transfer'), colorKey: 'cyan' },
  { value: OperateEnum.TEMPORARY, label: i18next.t('inventory.temporary'), colorKey: 'magenta' },
  { value: OperateEnum.PICKING, label: i18next.t('warehouse.sourcesPick'), colorKey: 'orange' },
  { value: OperateEnum.IN_RETURN, label: i18next.t('warehouse.sourcesInReturn'), colorKey: 'volcano' },
  { value: OperateEnum.OUT_RETURN, label: i18next.t('warehouse.sourcesOutReturn'), colorKey: 'green' },
  { value: OperateEnum.PROD_IN, label: i18next.t('warehouse.proIn'), colorKey: 'geekblue' },
  { value: OperateEnum.MATERIAL_OVER_ISSUE, label: i18next.t('reimburse.materialOverIssue'), colorKey: 'red' },
  { value: OperateEnum.SHIPMENT_OUT, label: i18next.t('warehouse.shipmentOut'), colorKey: 'blue' },
]

export const opTypes2 = [
  { value: OperateEnum2.SURPLUS, label: i18next.t('warehouse.surplus'), colorKey: 'blue' },
  { value: OperateEnum2.DEFECTIVE, label: i18next.t('warehouse.defective'), colorKey: 'red' },
  { value: OperateEnum2.REFURBISHED, label: i18next.t('warehouse.refurbished'), colorKey: 'gold' },
  { value: OperateEnum2.REOUTRECVD, label: i18next.t('warehouse.reoutrecvdpicking'), colorKey: 'geekblue' },
]

export const zhVnOpTypes2 = [
  { value: OperateEnum2.SURPLUS, label: `${i18next.t('warehouse.surplus', { lng: "zh" })}/${i18next.t('warehouse.surplus', { lng: "vn" })}`, colorKey: 'blue' },
  { value: OperateEnum2.DEFECTIVE, label: `${i18next.t('warehouse.defective', { lng: "zh" })}/${i18next.t('warehouse.defective', { lng: "vn" })}`, colorKey: 'red' },
  { value: OperateEnum2.REFURBISHED, label: `${i18next.t('warehouse.refurbished', { lng: "zh" })}/${i18next.t('warehouse.refurbished', { lng: "vn" })}`, colorKey: 'gold' },
  { value: OperateEnum2.REOUTRECVD, label: `${i18next.t('warehouse.reoutrecvdpicking', { lng: "zh" })}/${i18next.t('warehouse.reoutrecvdpicking', { lng: "vn" })}`, colorKey: 'geekblue' },
]

export const changeTypes = [
  { value: ChangeEnum.IN, label: i18next.t('inventory.inbound'), colorKey: 'blue' },
  // { value: ChangeEnum.TEMP_IN, label: i18next.t('warehouse.tempIn'), colorKey: 'blue' },
  { value: ChangeEnum.OUT, label: i18next.t('inventory.outbound'), colorKey: 'red' },
  // { value: ChangeEnum.TEMP_OUT, label: i18next.t('warehouse.otherOut'), colorKey: 'red' },
  { value: ChangeEnum.PRE_IN, label: `${i18next.t('purchase.delivery')}/${i18next.t('purchase.preInventory')}`, colorKey: 'blue' },
  { value: ChangeEnum.PRE_OUT, label: i18next.t('inventory.perOutbound'), colorKey: 'red' },
]

export const zhVnChangeTypes = [
  { value: ChangeEnum.IN, label: `${i18next.t('inventory.inbound', { lng: "zh" })}/${i18next.t('inventory.inbound', { lng: "vn" })}`, colorKey: 'blue' },
  { value: ChangeEnum.TEMP_IN, label: `${i18next.t('warehouse.tempIn', { lng: "zh" })}/${i18next.t('warehouse.tempIn', { lng: "vn" })}`, colorKey: 'blue' },
  { value: ChangeEnum.OUT, label: `${i18next.t('inventory.outbound', { lng: "zh" })}/${i18next.t('inventory.outbound', { lng: "vn" })}`, colorKey: 'red' },
  { value: ChangeEnum.TEMP_OUT, label: `${i18next.t('warehouse.otherOut', { lng: "zh" })}/${i18next.t('warehouse.otherOut', { lng: "vn" })}`, colorKey: 'red' },
  { value: ChangeEnum.PRE_IN, label: `${i18next.t('purchase.preInventory', { lng: "zh" })}/${i18next.t('purchase.delivery', { lng: "zh" })}/${i18next.t('purchase.preInventory', { lng: "vn" })}/${i18next.t('purchase.delivery', { lng: "vn" })}`, colorKey: 'blue' },
  { value: ChangeEnum.PRE_OUT, label: `${i18next.t('inventory.perOutbound', { lng: "zh" })}/${i18next.t('inventory.perOutbound', { lng: "vn" })}`, colorKey: 'red' },
]

export const orderTypes = [
  { value: OrderEnum.SCAN, label: i18next.t('inventory.scanOrder'), colorKey: 'geekblue' },
  { value: OrderEnum.COUNT, label: i18next.t('inventory.inputOrder'), colorKey: 'green' }
]

export const confirmTypes = [
  { value: ConfirmedEnum.NOTCONFIRM, label: i18next.t('inventory.beConfirmed'), colorKey: 'red' },
  { value: ConfirmedEnum.CONFIRM, label: i18next.t('inventory.confirmed'), colorKey: 'blue' }
]

export const countingStatus = [
  { value: CountingStateEnum.PENDING, label: i18next.t('inventory.invInProgress'), colorKey: 'red' },
  { value: CountingStateEnum.COUNTING, label: i18next.t('inventory.genertDifferences'), colorKey: 'blue' },
  { value: CountingStateEnum.IN, label: i18next.t('inventory.cpletDifIn'), colorKey: 'gold' },
  { value: CountingStateEnum.OUT, label: i18next.t('inventory.cpletDifOut'), colorKey: 'magenta' },
  { value: CountingStateEnum.DONE, label: i18next.t('inventory.cplet'), colorKey: 'green' }
]

// export const locationTypes = [
//   { value: LocationTypeEnum.NORMAL, label: `${i18next.t('inventory.normalType', { lng: 'zh' })}/${i18next.t('inventory.normalType', { lng: 'vn' })}`, colorKey: 'blue' },
//   { value: LocationTypeEnum.COMPLETE, label: `${i18next.t('inventory.completeType', { lng: 'zh' })}/${i18next.t('inventory.completeType', { lng: 'vn' })}`, colorKey: 'green' },
//   { value: LocationTypeEnum.WASTED, label: `${i18next.t('inventory.wastedType', { lng: 'zh' })}/${i18next.t('inventory.wastedType', { lng: 'vn' })}`, colorKey: 'red' },
//   { value: LocationTypeEnum.TEMP, label: `${i18next.t('inventory.tempType', { lng: 'zh' })}/${i18next.t('inventory.tempType', { lng: 'vn' })}`, colorKey: 'magenta' },
//   { value: LocationTypeEnum.OUTTER, label: `${i18next.t('inventory.outter', { lng: 'zh' })}/${i18next.t('inventory.outter', { lng: 'vn' })}`, colorKey: 'orange' },
//   { value: LocationTypeEnum.PRODUCTION, label: `${i18next.t('inventory.productionType', { lng: 'zh' })}/${i18next.t('inventory.productionType', { lng: 'vn' })}`, colorKey: 'geekblue' },
//   { value: LocationTypeEnum.DEFECTIVE_RETURN, label: `${i18next.t('inventory.defectiveReturnType', { lng: 'zh' })}/${i18next.t('inventory.defectiveReturnType', { lng: 'vn' })}`, colorKey: 'volcano' },
//   { value: LocationTypeEnum.DEFECTIVE_TEMP, label: `${i18next.t('inventory.defectiveTempType', { lng: 'zh' })}/${i18next.t('inventory.defectiveTempType', { lng: 'vn' })}`, colorKey: 'gold' },
// ]

export const CODES_MAX = {
  scanMax: 10, // 单次出入库扫描单最大数量
  barcodeMax: 500, // 单个扫描单 条码最大数量 
}


export const getLocationCode: (locationData: WLocation | null | undefined) => string = (locationData) => {
  // if (locationData) return [locationData.l1, locationData.l2, locationData.l3, locationData.l4, locationData.l5].join('-')
  if (locationData) return locationData?.number || ''
  return ''
}